import { createAction, props } from '@ngrx/store'
import {
    AttachmentDto, ContractRelatedDto,
    ContractSignatureDocumentDto,
    IncomingPaymentGroupedByYearContractDto, OutgoingPaymentGroupedByYearContractDto, ParcelContractForContractDetailDto, Subject,
} from '../../../../../api/backend'
import { ExtendedParcelContractForContractDetailDto } from '../../model/ExtendedParcelContractForContractDetailDto.model'

export const SOURCE = '[Subcontract Show]'

export const resetState = createAction(
    `${ SOURCE } ResetState`,
)

export const prepareAndSetContract = createAction(
    `${ SOURCE } PrepareAndSetContract`, props<{ contract: any }>(),
)

export const setContract = createAction(
    `${ SOURCE } SetContract`, props<{ contract: any }>(),
)
export const setIsAppendix = createAction(
    `${ SOURCE } SetIsAppendix`, props<{ isAppendix: boolean }>(),
)
export const setAllowEdit = createAction(
    `${ SOURCE } SetAllowEdit`, props<{ allowEdit: boolean }>(),
)
export const setContractNote = createAction(
    `${SOURCE} SetContractNote`, props<{ note: string }>()
)
export const setContractCpds = createAction(
    `${ SOURCE } SetContractCpds`, props<{ cpds: any[] }>(),
)
export const prepareAndSetParcels = createAction(
    `${ SOURCE } PrepareAndSetParcels`, props<{ parcels: ParcelContractForContractDetailDto[]; drupozs: any[]; zpvypos: any[]; parcelsOrder?: {sortedBy: string; desc: boolean} }>(),
)
export const setParcels = createAction(
    `${ SOURCE } SetParcels`, props<{ parcels: ExtendedParcelContractForContractDetailDto[] }>(),
)
export const setSameLVAndKatuze = createAction(
    `${ SOURCE } SetSameLVAndKatuze`, props<{ sameLVAndKatuze: boolean }>(),
)
export const setContractOwnerParams = createAction(
    `${ SOURCE } SetContractOwnerParams`, props<{ ownerparams: any }>(),
)
export const orderParcels = createAction(
    `${ SOURCE } OrderParcels`, props<{ orderBy: string; parcelsOrder: any }>(),
)
export const setContractEnd = createAction(
    `${ SOURCE } SetContractEnd`, props<{ endType: string; endDate: string; resignDate: string; expirationDate: string }>(),
)
export const setAttachmentsLoading = createAction(
    `${ SOURCE } SetAttachmentsLoading`, props<{ attachmentsLoading: boolean }>(),
)
export const setContractSignatureDocuments = createAction(
    `${ SOURCE } SetContractSignatureDocuments`, props<{ signatureDocuments: ContractSignatureDocumentDto[] }>(),
)
export const setContractSignatureDocumentsGroup = createAction(
    `${ SOURCE } SetContractSignatureDocumentsGroup`, props<{ signatureDocuments: ContractSignatureDocumentDto[] }>(),
)
export const setAttachments = createAction(
    `${ SOURCE } SetAttachments`, props<{ attachments: AttachmentDto[] }>(),
)
export const loadIncomingPayments = createAction(
    `${ SOURCE } LoadIncomingPayments`, props<{ contractId: number }>(),
)
export const setIncomingPayments = createAction(
    `${ SOURCE } SetIncomingPayments`, props<{ incomingPayments: IncomingPaymentGroupedByYearContractDto[] }>(),
)
export const loadOutgoingPayments = createAction(
    `${ SOURCE } LoadOutgoingPayments`, props<{ contractId: number }>(),
)
export const setOutgoingPayments = createAction(
    `${ SOURCE } SetOutgoingPayments`, props<{ outgoingPayments: OutgoingPaymentGroupedByYearContractDto[] }>(),
)
export const setCurrentYearPaymentReady = createAction(
    `${ SOURCE } SetCurrentYearPaymentReady`, props<{ currentYearPaymentReady: boolean }>(),
)
export const setAttachmentOnlineDocumentLink = createAction(
    `${ SOURCE } SetAttachmentOnlineDocumentLink`, props<{ id: number; link: string }>(),
)
export const setParcelsOrder = createAction(
    `${SOURCE} SetParcelsOrder`, props<{ parcelsOrder: {sortedBy: string; desc: boolean} }>()
)

export const updateContractOwners = createAction(
    `${SOURCE} UpdateContractOwners`, props<{ owners: Subject[] }>()
)
export const updateContractTenants = createAction(
    `${SOURCE} UpdateContractTenants`, props<{ tenants: Subject[] }>()
)

export const loadContractOwnersRepresentatives = createAction(
    `${ SOURCE } LoadContractOwnersRepresentatives`,
)

export const loadContractTenantsRepresentatives = createAction(
    `${ SOURCE } loadContractTenantsRepresentatives`,
)
export const setRelatedContracts = createAction(
    `${SOURCE} SetRelatedContracts`, props<{ relatedContracts: ContractRelatedDto[] }>()
)